var AppComponent = /** @class */ (function () {
    function AppComponent() {
        this.title = 'melodic-alignment-tool';
    }
    return AppComponent;
}());
export { AppComponent };
